import {
  Card,
  Text,
  BlockStack,
  Button,
  Layout,
  InlineGrid,
} from "@shopify/polaris";
import { useState, useCallback, useEffect } from "react";

import { q_e_log, d_e_log } from "../api";

export default function ErrorTable({ canDelete = false }) {
  const [desList, setdescList] = useState([]);

  useEffect(() => {
    queryErrorLog();
  }, []);

  const handleDelete = async (id) => {
    try {
      const deleteResponse = await d_e_log({ ids: [id] });
      if (deleteResponse.status === 200) {
        queryErrorLog();
      } else {
        console.error("Failed to delete log:", deleteResponse);
      }
    } catch (error) {
      console.error("Error deleting log:", error);
    }
  };

  const queryErrorLog = async () => {
    try {
      const response = await q_e_log({});
      if (response.status === 200) {
        setdescList(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <Layout.Section>
        <BlockStack gap="400">
          {desList.map((item) => {

            const date = new Date(item.create_time * 1000);
            const usTime = date.toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });

            return (
              <Card key={item.id}>
                <InlineGrid columns={["2fr", "3fr", "1fr"]} gap="200">
                  <div>
                    <Text variant="headingSm" as="h6">
                      {item.url}
                    </Text>
                  </div>
                  <div>
                    <BlockStack gap="100">
                      <Text variant="bodySm" as="p">
                        {item.error_message}
                      </Text>
                      <Text variant="bodySm" as="p">
                        Browser: {item.browser_info}
                      </Text>
                      <Text variant="bodySm" as="p">
                        Device: {item.device_info}
                      </Text>
                      <Text variant="bodySm" as="p">
                        IP: {item.ip_address}
                      </Text>
                      <Text variant="bodySm" as="p">
                        Time: {usTime}
                      </Text>
                    </BlockStack>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {canDelete && <Button
                      variant="plain"
                      tone="critical"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </Button>}
                  </div>
                </InlineGrid>
              </Card>
            );
          })}
        </BlockStack>
      </Layout.Section>
    </Layout>
  );
}
